import { Component, Input, OnInit } from '@angular/core';

import { RevenueChartData } from '../../models';
import {colors} from '../../../../consts';

@Component({
  selector: 'app-revenue-chart',
  templateUrl: './revenue-chart.component.html',
  styleUrls: ['./revenue-chart.component.scss']
})
export class RevenueChartComponent implements OnInit {
  //@Input() revenueCharData: RevenueChartData;
  @Input() revenueCharData: any;
  public revenueChart: any;
  public colors: typeof colors = colors;
  @Input()
  public chartTitle:string;

  public ngOnInit(): void {
   // this.chartTitle;
    this.initChart();
  }

  public initChart(): void {
    this.revenueChart = {
      color: ['#353432', '#196774', '#91A19E' ,'#F1931F', '#EF6024'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: 'center',
        right: 'right',
        data: ['Group A', 'Group B', 'Group C', 'Group D' ,'Group E'],
        textStyle: {
          color: '#6E6E6E'
        }
      },
      series: [{
        type: 'pie',
        radius: ['90%', '100%'],
        center: ['24%', '50%'],
        label: {
          show: false
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        hoverAnimation: false,
        avoidLabelOverlap: false,
        data: [
          {
           //name: 'Group A',
            value: this.revenueCharData.groupA
          },
          {
           // name: 'Group B',
            value: this.revenueCharData.groupB
          },
          {
           // name: 'Group C',
            value: this.revenueCharData.groupC
          },
          {
           // name: 'Group D',
            value: this.revenueCharData.groupD
          },
          {
            // name: 'Group D',
             value: this.revenueCharData.groupE
           },
        ]
      }]
    };
  }
}
